<script>
import { layoutMethods,eloadProviderMethods } from '@/state/helpers';
import appConfig from "@/app.config";
import moment from 'moment-timezone';
import { getModuleAccess } from '../../../../router/helper';//'./helper.js'//showAccessRestrictedModal

/**
 * Provider component
 */
export default {
  page: {
    title: "Provider",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "EloadProvider",
      items: [
        {
          text: "Peddlr",
        },
        {
          text: "Overview",
          active: true,
        },
      ],
      tblData:[],
      tblCount: 0,
      fields:[
        {key: "action", sortable: false},
        {key: "provider", sortable: true},
        {key: "balance", sortable: true},
        {key: "prevLoadOut", sortable: true, label: "Daily Load Out"},
        {key: "aveLoadOut", sortable: true, label: "Ave. Load Out"},
        {key: "daysStockCover", sortable: true},
        {key: "dateUpdated", sortable: true},
      ],
      searchValue: {
        sort: 'id',
        orderDesc: true,
        page: 1,
        rows: 10,
      },
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      sortBy: "value",
      sortDesc: false,
      hasUpdateAccess: false
    };
  },
  methods: {
    ...layoutMethods,
    ...eloadProviderMethods,
    tableSort(ctx){//context
      this.searchValue.sort = ctx.sortBy;
      this.searchValue.orderDesc = ctx.sortDesc;
      // console.log(">> sorting...",ctx);
      this.onSearch('reset');
    },
    rowClass(item) {
      const test = item && item.daysStockCover < 1 && item.avgTotalTransactions > 0;
      return test ? 'stock-red' : '';
    },
    async onSearch(state = ''){
        if(state == 'reset'){
          this.searchValue.page = 1;
        }
        await this.actionEloadProvider({
            action: "list",
            body: this.searchValue
        }).then(({message})=>{
            this.tblData = message?.rows??[]
            this.tblCount = message?.pageInfo.total??0
        }).catch((err)=>{
            console.log("err", err);
        })
    },
    isValidDate(date){
      return moment(date).isValid()
    },
    async refreshBalance(provider,digicoreId){
        await this.actionEloadProvider({
            action: "balance",
            body: {provider:provider, digicoreId:digicoreId}
        }).then(({message})=>{
            // console.log("res",JSON.stringify(res));
            if(provider == "all"){
              this.onSearch();
            }else{
              this.tblData.forEach(e => {
                if(e.provider == provider){
                  e.balance = message?.balance??null
                  e.dateUpdated = message?.dateUpdated??null
                  e.avgTotalTransactions = message?.avgTotalTransactions
                  e.previousTotalTransactions = message?.previousTotalTransactions
                  e.daysStockCover = message?.daysStockCover
                }
              });
            }
        }).catch((err)=>{
            console.log("err", err);
        })
    },
    async ableToUpdate(){
        await getModuleAccess('Dashboard', 'Eload Proviver').then((access) => {
          // console.log("::: eLoad Provider :::",access);
          this.hasUpdateAccess = access?.update??false
        })
    }
  },
  computed: {
  },
  mounted(){
    this.changeTitle({title: 'Eload Provider'});
    this.changeBreadCrumb({
      breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Overview', to: { name: 'Home'} },
          { text: 'Eload Provider', to: { name: 'Eload Provider'} }
      ]
    });
    this.onSearch("reset");
    this.ableToUpdate();
  },
  components: {
  },
};
</script>

<template>
    <div class="row">
        <div class="col-12">
            <!-- Card -->
            <div class="card">
                <div class="card-body">
                  <h5 class="float-start card-title text-dark font-size-20" @click="onSearch()">
                      <span class="fw-normal ms-lg-2"> {{ tblCount }} </span> Record(s)
                  </h5>
                  <div class="mb-2 d-flex flex-wrap flex-row-reverse">
                    <a class="btn btn-secondary" @click="refreshBalance('all','')" v-if="hasUpdateAccess">
                      <feather type="refresh-ccw" size="16" class="icon nav-icon me-2"></feather>Refresh All
                    </a>
                    <div v-else class="p-4">

                    </div>
                  </div>

                  <div class="table-responsive">
                    <div class="table align-middle table-nowrap">
                      <b-table
                        :items="tblData"
                        :fields="fields"
                        responsive="sm"
                        :current-page="searchValue.page"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        class="table-check"
                        @sort-changed="tableSort" 
                        :tbody-tr-class="rowClass"
                      >

                        <template #cell(action)="data">
                          <div v-if="hasUpdateAccess">
                            <button class="btn btn-primary btn-refresh" v-if="data.item.balance != null" @click="refreshBalance(data.item.provider, data.item.digicore_id)">
                              <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>
                            </button>
                            <button class="btn btn-primary btn-refresh" disabled v-else>
                              <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>
                            </button>
                          </div>
                        </template>
                        <template #cell(provider)="data">
                          {{ data.item.label}}
                        </template>
                        <template #cell(balance)="data">
                          <div class="text-end">
                            <div v-if="data.item.balance != null ">
                              ₱ <span :class="data.item.daysStockCover < 1 && data.item.avgTotalTransactions > 0 ? 'text-stock-red' : ''">{{ data.item.balance  |  numberWithCommas(0)}}</span>
                            </div>
                            <div v-else>
                              <span class="text-muted">Unavailable</span>
                            </div>
                          </div>
                        </template>                        
                        <template #cell(prevLoadOut)="data">
                          <div class="text-end">
                            ₱ <span :class="data.item.daysStockCover < 1 && data.item.avgTotalTransactions > 0 ? 'text-stock-red' : ''">{{ data.item.previousTotalTransactions  |  numberWithCommas(0)}}</span>
                          </div>
                        </template>
                        <template #cell(aveLoadOut)="data">
                          <div class="text-end">
                            ₱ <span :class="data.item.daysStockCover < 1 && data.item.avgTotalTransactions > 0 ? 'text-stock-red' : ''">{{ data.item.avgTotalTransactions  |  numberWithCommas(0)}}</span>
                          </div>
                        </template>
                        <template #cell(daysStockCover)="data">
                          <div class="text-center">
                            <span :class="data.item.daysStockCover < 1 && data.item.avgTotalTransactions > 0 ? 'text-stock-red' : ''">{{ data.item.daysStockCover  |  numberWithCommas(1)}}</span>
                          </div>
                        </template>
                        <template #cell(dateUpdated)="data">
                          <div class="">
                            <div v-if="isValidDate(data.item.dateUpdated)">
                              {{ data.item.dateUpdated |  formatDate}}
                            </div>
                            <div v-else class="text-muted">
                              --
                            </div>
                          </div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                  <!-- end table responsive -->
                  <div class="row g-0 text-center" v-if="tblCount == 0">
                    <span>No data to display.</span>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="form-group row pull-left">
                        <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                        <div class="col-sm-6">
                          <b-form-group label-for="display-record">
                            <b-form-select class="form-select shadow-none w-fit"
                              id="display-record"
                              v-model="searchValue.rows"
                              :options="pageOptions"
                              @change="onSearch('reset')"
                            ></b-form-select>
                          </b-form-group>
                        </div>
                      </div>
                      <div
                        class="
                          dataTables_paginate
                          paging_simple_numbers
                          float-end
                        "
                      >
                        <b-pagination
                          v-if="tblCount != 0 && tblCount > searchValue.rows"
                          class="pagination-rounded"
                          v-model="searchValue.page"
                          :total-rows="tblCount"
                          @input="onSearch()"
                          :per-page="searchValue.rows"
                        ></b-pagination>
                      </div>
                    </div>
                  </div>


                </div>
            </div>
        </div>
    </div>
</template>

<style scope>
.text-muted{
  color: #ACACAC !important;
}
</style>
<style>
.stock-red td{
  background-color: #FFF2F2 !important;
}
.text-stock-red {
  color: #f00;
}
.btn-refresh {
    width: 35px;
    height: 25px;
    line-height: 1.0;
    padding:0px;
}
.feather__content[data-v-4d521fc4] {
  width: 13px !important;
}
.b-table > tbody > tr > td {
   padding: 8px 8px;
   vertical-align: middle;
}

</style>